import type { PlayLimits } from './types';
const MAX128 = (1n << 128n) - 1n;
export function validateLimits(l: PlayLimits) {
  if (!Number.isInteger(l.duration) || l.duration < 60 || l.duration > 3600) throw new Error('Choose a session between 1 and 60 minutes.');
  for (const value of [l.buyBudget, l.sellBudget, l.maxBuy, l.maxSell]) if (value < 0n || value > MAX128) throw new Error('Invalid play limit.');
  if (l.buyBudget + l.sellBudget === 0n || l.maxBuy > l.buyBudget || l.maxSell > l.sellBudget || (l.buyBudget > 0n && l.maxBuy === 0n) || (l.sellBudget > 0n && l.maxSell === 0n)) throw new Error('Each enabled side needs a positive per-action limit within its total budget.');
}
